import { useState } from "react";
import { useShedConfig } from "../../contexts/ShedConfigContext";
import Modal from "./Modal";

export default function PlacementConfirmModal() {
  const { configApplied } = useShedConfig();
  const [dismissed, setDismissed] = useState(false);

  // Derive isOpen from configApplied and dismissed state
  const isOpen = configApplied && !dismissed;

  const handleConfirm = () => {
    setDismissed(true);
  };

  const warningIcon = (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.232 18.5c-.77.833.192 2.5 1.732 2.5z"
      />
    </svg>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleConfirm}
      title="Confirm Shed Placement"
      icon={warningIcon}
      iconBgColor="bg-yellow-100"
      iconColor="text-yellow-600"
    >
      <p className="text-sm text-gray-600 text-center mb-6">
        All installation settings have been saved to the PDF. After closing this
        message, please verify that the shed is correctly positioned and
        oriented before proceeding.
      </p>

      <div className="flex justify-center">
        <button
          type="button"
          onClick={handleConfirm}
          className="px-6 py-2 text-sm font-medium text-white bg-[#2f5241] border border-transparent rounded-md hover:bg-[#2f5241e1] focus:outline-none focus:ring-2 focus:ring-[#2f5241] focus:ring-offset-2 transition-colors hover:cursor-pointer"
        >
          Continue
        </button>
      </div>
    </Modal>
  );
}
